export default "__VITE_ASSET__DdPPwtC4__"